export const WEB_ADDRESS = 'https://quickorganics.com'
export const SITE_NAME = 'Quick Organics'
